// Generated by CoffeeScript 1.12.7

/*
Generate unique ids to identify each sortable element on the page
 */

(function() {
  angular.module('smart-table').factory('stUniqueId', function() {
    var id;
    id = 0;
    return {
      generate: function() {
        return id++;
      }
    };
  });

}).call(this);
